import { useTranslation } from 'react-i18next';
import { useSiteImage } from '@/hooks/useSiteImage';

export default function TheCompany() {
  const { t } = useTranslation();
  const productImageUrl = useSiteImage('brandStory.company.productImage', 'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/fdd440f4-784c-4da5-987e-9e32258180b3_RX.K-Seoul-Total-Solution3-Step_Transparent.jpg');
  const logoBadgeUrl = useSiteImage('brandStory.company.logoBadge', 'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/3c5db519-2e35-47da-80f5-87ad39c44364_The.K-Seoul-Logo-Sqaure_1_d.png');

  const stats = [
    { icon: 'ri-flag-line', label: t('brandStory.company.stat1Label'), value: t('brandStory.company.stat1') },
    { icon: 'ri-hospital-line', label: t('brandStory.company.stat2Label'), value: t('brandStory.company.stat2') },
    { icon: 'ri-test-tube-line', label: t('brandStory.company.stat3Label'), value: t('brandStory.company.stat3') },
  ];

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Image */}
          <div className="relative rounded-2xl overflow-hidden h-80 md:h-[480px] bg-[#F0EFED]">
            <img
              src={productImageUrl}
              alt="The.K Seoul Co., Ltd. — Rx.K Seoul 3-Step Set"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right: Text */}
          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-[#7B1113]" />
              <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">
                {t('brandStory.company.label')}
              </span>
              <img
                src={logoBadgeUrl}
                alt="The.K Seoul Co., Ltd."
                className="h-5 w-auto"
              />
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-[1.15]">
              {t('brandStory.company.heading')}
            </h2>

            <div className="flex flex-col gap-4">
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                {t('brandStory.company.p1')}
              </p>
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                {t('brandStory.company.p2')}
              </p>
            </div>

            {/* Signature block */}
            <div className="flex flex-col items-end gap-1 mt-2">
              <div className="w-32 h-10 bg-[#F0EFED] rounded flex items-center justify-center">
                <span className="font-serif italic text-sm text-[#2A2A2A]/40 select-none">
                  {t('brandStory.company.signatureName')}
                </span>
              </div>
              <span className="text-[10px] text-[#8A8A8A] font-light">
                {t('brandStory.company.signatureCaption')}
              </span>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mt-4 pt-6 border-t border-[#F0EFED]">
              {stats.map((stat) => (
                <div key={stat.label} className="flex flex-col items-center gap-2 text-center">
                  <div className="w-12 h-12 rounded-full bg-[#F0EFED] flex items-center justify-center">
                    <i className={`${stat.icon} text-[#1B3A5C] text-lg`} />
                  </div>
                  <span className="text-[10px] tracking-[0.12em] uppercase text-[#2A2A2A] font-medium">
                    {stat.value}
                  </span>
                  <span className="text-[9px] text-[#8A8A8A] font-light leading-[1.4]">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}